import type { ReactNode } from "react";
import styles from "./simpleFieldset.module.scss";

interface SimpleFieldsetProps {
  legend: string;
  children: ReactNode;
}

export function SimpleFieldset({ legend, children }: SimpleFieldsetProps) {
  return (
    <fieldset className={styles.fieldset}>
      {legend && <legend className={styles.legend}>{legend}</legend>}
      {children}
    </fieldset>
  );
}
